import '../css/app.scss';
import './script/neto.js';
import { addEvent, appHeight } from './script/utils';

addEvent();
appHeight();
